import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Collapse, IconButton,
    LinearProgress, Paper,
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    Tooltip,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CreateIcon from '@material-ui/icons/Create';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ImageIcon from '@material-ui/icons/Image';
import {ErrorGeneral, llamaApiCargaToken} from '../../funciones/ClienteAxios';
import NuevaBitacora from './NvoEditIncidencia';
import ModalEvidencia from './ModalEvidencia';
import Viewer from 'react-viewer';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaIncidencias({   regisMaquinaria,   }) {
    const classes = useStyles();
    let history = useHistory();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const [registro, setRegistro] = useState([]);
 
    const [open, setOpen] = useState(false);
    const [espera, setEspera] = useState(false);
    const [espera2, setEspera2] = useState(false);
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [seleccionadoEdit, setSeleccionadoEdit] = useState([]);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modalEvid, setModalEvid] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)    
    const [modNvo, setModNvo] = useState(false)    
    const [listIMG, setListIMG] = useState([])
    const [visibleGaleria, setVisibleGaleria ] = useState(false);
    const [maxSteps, setMaxSteps] =  useState(0);  
    const [auxTitulo, setAuxTitulo] =  useState("");  

    useEffect(() => {                  
        
        getListTabla(regisMaquinaria.Id)
        return () => {
            source.cancel();
        }
    }, [regisMaquinaria]);

      const getListTabla = (Maquinaria) => {        
        
        const data = qs.stringify({
            Usuario:idusu,
            Maquinaria: Maquinaria,
            ip:"172.2.2.2",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/incidencia";

        function respuestaListTabla(aux) {
            if (aux[0].Id !== -1) {
                guardarDatos(aux)                                     
            }
            else{guardarDatos([])} 
        }

        llamaApiCargaToken(data, url, respuestaListTabla, ErrorGeneral, setEspera, history, source);
    };   

 
    const getListGaleria = (Maquinaria) => {        
        
        const data = qs.stringify({
            Usuario:idusu,
            Incidencia: Maquinaria,
            ip:"172.2.2.2",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/incidencia/evidencia";

        function respuestaListTabla(aux) {
            if (aux[0].Id !== -1) {
                setListIMG(aux)              
                setVisibleGaleria(true)                       
            } 
        }

        llamaApiCargaToken(data, url, respuestaListTabla, ErrorGeneral, setEspera2, history, source);
    };   


    const seleccionado = (auxReg) => {
        setRegistro(auxReg)       
    }

    function editarFall(auxFalla) {
        setSeleccionadoEdit(auxFalla)

        setModalAbierto(true)
    }

    function subirEvid(valor) {
        setAuxTitulo(moment.parseZone(valor.FCap ).local(true).format("DD/MM/YYYY"))
        setModalEvid(true)
    }

    function verMas(auxId) {

        if (auxId === ordenSelecc) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo}

    function Row(props) {
        const {row} = props;
        //console.log("nuevo");
        
        return (
        <TableRow onClick={() => { seleccionado(row); }}
            className={classes.tableRow} selected={registro?.Id === row.Id}
            classes={{hover: classes.hover, selected: classes.selected}}
        >
         
            <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                {registro?.Id === row.Id ?
                    <Tooltip title={'Subir Evidencias'}>
                        <IconButton color="primary" aria-label="expand row" size="small"
                            onClick={() => subirEvid(row.Id)}>
                             <ImageIcon style={{color: registro?.Id === row.Id ? 'white':""}}/>                                                      
                        </IconButton>
                    </Tooltip>:null}
            </TableCell>  
            <TableCell align="center" padding={'none'} style={{width: 30 + 'px'}}>
                {registro?.Id === row.Id && row.ImgTotal>0 ?
                <Tooltip title={'Ver Galeria'}>
                        <IconButton color="primary" aria-label="expand row" size="small"
                        onClick={() => getListGaleria(row.Id)}>
                            <PhotoLibraryIcon style={{color: registro?.Id === row.Id ? 'white':""}}/>                                                      
                    </IconButton>
                </Tooltip>:null}
            </TableCell> 
            <TableCell className={classes.tableCell} align="center" padding={'none'} style={{width: 120 + 'px'}}>
                {moment.utc(row.FCap).local(true).format("DD/MM/YYYY")}
            </TableCell>
            {/*   <TableCell className={classes.tableCell} align="center" style={{   width: 50 + 'px'}}
                padding={'none'}>{row.RefId !== 0 ? row.RefNom :""}
            </TableCell> */}
            <TableCell className={classes.tableCell} align="left" style={{   paddingLeft:"8px"}}
                padding={'none'}>{row.TipoNom}
            </TableCell>
            <TableCell className={classes.tableCell} align="left" style={{   paddingLeft:"8px"}}
                padding={'none'}>{row.Descr}
            </TableCell>
        </TableRow>                  
        );
    }

    function tablaCompleta(auxlista) {        
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" padding='none'></TableCell>  
                    <TableCell align="center" padding='none'></TableCell>         
                    <TableCell align="center" padding='none' >                          
                        <IconButton onClick={()=>setModNvo(true)}>
                            <Tooltip title="Nueva Bitacora">
                                <AddCircleOutlineIcon/>
                            </Tooltip>
                        </IconButton> {`  Fecha`}</TableCell>
                    <TableCell align="center" padding='none'>Tipo</TableCell> 
             {/*        <TableCell align="center" padding='none'>Refacción</TableCell> */}
                    <TableCell align="center" padding='none'>Descripción </TableCell>                                                              
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length !== 0 ? (auxlista.map((row) => (
                     <Row key={row.Id} row={row}/>
                    
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" padding='none'>
                            <IconButton onClick={()=>setModNvo(true)}>
                                <Tooltip title="Nueva Incidencia">
                                    <AddCircleOutlineIcon/>
                                </Tooltip>
                            </IconButton>  
                        </TableCell>
                        <TableCell align="left" padding='none'>Fecha</TableCell>
                      
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow  className={classes.tableRow} >
                        
                        <TableCell className={classes.tableCell} align="left" padding='none'>Sin</TableCell>
                        <TableCell className={classes.tableCell} align="left" padding='none'>Registros</TableCell>

                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        )
    }

    const tablaSinResultados = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">  </TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow} >
                   
                    <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                    <TableCell className={classes.tableCell} align="left">coincidencias</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const Galeria =()=>{
        return<Viewer      zIndex={2000}
          visible={visibleGaleria} onClose={() => { setVisibleGaleria(false); } }
          images={
            listIMG.map((imagen,index)=>{
              return({src: imagen.Dir+imagen.Archivo, alt: ''})
            })
          }
        />
    }
    
    const modEvidencia = modalEvid ? <ModalEvidencia modalAbierto={modalEvid} orden={registro} setMaxSteps={setMaxSteps}
                                datos={datos}                                 
                                setModalAbierto={setModalEvid} titulo={"Seleccione una imagen para "+auxTitulo} />:null

    const modNvoBit = modNvo ?<NuevaBitacora modalAbierto={modNvo} setModalAbierto={setModNvo} regInci={[]}
                                titulo={"Nueva Incidencia"} regisMaquinaria={regisMaquinaria} funcionActuliza={getListTabla} /> :null
    const contenido = datos.length !== 0 && datos[0].Id !== "-1" &&datos[0].Id !== -1 ? tablaCompleta(datos) : tablaSinDatos()
    const tabla = espera ? (<Box style={{paddingTop:"5rem"}} ><LinearProgress/> </Box>) : (contenido)
 
    return (
    <Paper className={classes.root}>
        {visibleGaleria ? Galeria():null}
        {tabla}
        {modNvoBit}
        {modEvidencia}
    </Paper>
    );
}